import { Box, Typography } from '@mui/material';
import { Vault } from '../../types/vaults';
import vaultArrow from '../../assets/vaultArrow.svg';
import usdcIcon from '../../assets/crypto/usdc.svg';
import usdtIcon from '../../assets/crypto/usdt.svg';
import ethIcon from '../../assets/crypto/eth.svg';
import cbbtcIcon from '../../assets/crypto/cbbtc.svg';
import xaumIcon from '../../assets/crypto/xaum.svg';

import { FriendlyFormatNumber } from '../../Utils';
const commonTypographyStyles = {
  fontFamily: 'Inter',
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#FFFFFF'
};

type SupportedAsset = 'usdc' | 'usdt' | 'eth' | 'cbbtc' | 'xaum';

const iconMap: Record<SupportedAsset, string> = {
  usdc: usdcIcon,
  usdt: usdtIcon,
  eth: ethIcon,
  cbbtc: cbbtcIcon,
  xaum: xaumIcon
};

const vaultNameTypographyStyles = {
  fontFamily: 'Outfit',
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: '1.5rem',
  color: '#FFFFFF',
  flexGrow: 1
};

interface VaultCardProps {
  vault: Vault;
}

const VaultCard = ({ vault }: VaultCardProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '1rem',
      width: '100%',
      boxSizing: 'border-box',
      background: 'rgba(1, 171, 146, 0.12)',
      borderRadius: '1.5625rem',
      my: 2
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '1rem',
        width: '100%',
        maxWidth: '30.8125rem'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '0.625rem'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img
              src={iconMap[vault.asset.toLowerCase() as SupportedAsset]}
              alt={vault.name}
              style={{ width: '1.5rem', height: '1.5rem' }}
            />
          </Box>
          <Typography
            sx={{
              ...vaultNameTypographyStyles,
              fontSize: '1.5rem'
            }}
          >
            {vault.name}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            padding: '0.3125rem'
          }}
        >
          <a
            href={`https://app.morpho.org/vault?vault=${vault.address}&network=mainnet`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={vaultArrow} alt="vaultArrow" />
          </a>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: '1.875rem',
          width: '100%'
        }}
      >
        <Typography
          sx={{
            ...commonTypographyStyles
          }}
        >
          APY {Number(vault.apy.netApy).toFixed(2)}%
        </Typography>
        <Typography
          sx={{
            ...commonTypographyStyles
          }}
        >
          TVL {vault.tvl === null || vault.tvl == 0 ? '-' : `$${FriendlyFormatNumber(vault.tvl)}`}
        </Typography>
        <Typography
          sx={{
            ...commonTypographyStyles
          }}
        >
          Multiplier {vault.multiplier}X
        </Typography>
      </Box>
    </Box>
  </Box>
);

export default function MobileVaultsCards({ vaults }: { vaults: Vault[] }) {
  return (
    <Box sx={{ width: '100%' }}>
      {vaults
        .filter((vault) => vault.name === 'Relend USDC')
        .map((vault) => (
          <VaultCard key={vault.name} vault={vault} />
        ))}
    </Box>
  );
}
